import type {ToolCallMessagePartComponent} from '@assistant-ui/react';
import React from 'react';

import {createPreloadableLazyComponent} from '../../../../util/lazyImport';
import {ErrorBoundary} from '../../../ErrorBoundary';
import type {AgentActionArgs} from '../../agentActionHandlers';

/** Backend tool name; mirrors the inchat_panel.py contract. */
export const INCHAT_PANEL_TOOL_NAME = 'wbui__inchat_panel';

const inChatPanel = createPreloadableLazyComponent(
  () => import('./InChatPanel'),
  module => module.InChatPanel
);
const LazyInChatPanel = inChatPanel.Component;

/** Load and render a live, read-only Reports panel grid for an ARIA chart action. */
export const InChatPanelToolUI: ToolCallMessagePartComponent<
  AgentActionArgs
> = ({args, status}) => {
  // Wait for streamed tool arguments to complete before rendering
  if (status.type === 'running') {
    return null;
  }
  return (
    <ErrorBoundary
      silent
      onError={error => {
        console.error('[InChatPanel] render crash', error);
      }}
      renderError={() => (
        <p className="my-8 text-sm text-moon-500" role="alert">
          This chart could not be rendered.
        </p>
      )}>
      <React.Suspense fallback={null}>
        <LazyInChatPanel args={args} />
      </React.Suspense>
    </ErrorBoundary>
  );
};
